module.exports = __webpack_public_path__ + "media/promo/promo/images/arrow-top-4cfb655acf2d32acf819223a833bc097.svg";